import { Button, Stack, Typography } from '@mui/material'

import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

export * from './fragments'
export type State = {}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {}

export const LotteryCompletionTemplate: Template<State, Action> = () => {
  const { t } = useTranslation('lotteryCompletion')
  const { routerPages, routerNames } = useRouter()

  return (
    <BaseLayout margin header={{ title: t('title', '先行販売応募完了') }}>
      <Head title={routerNames.LotteryCompletion} />
      <Stack spacing={6} alignItems="center" sx={{ pt: '55px' }}>
        <Typography variant="h5">
          {t('applicationCompleted', '応募が完了しました')}
        </Typography>
        <Typography variant="body2" align="center">
          {t('applicationCompletedDesc')}
        </Typography>
      </Stack>
      <Stack alignItems="center" spacing={4} sx={{ pt: 6 }}>
        <Button
          href={routerPages.LotteryApplications}
          size="large"
          sx={{ width: 244 }}
        >
          {t('lotteryApplicationManagement', '抽選応募管理へ')}
        </Button>
        <Button
          href={routerPages.GlobalHome}
          variant="text"
          size="large"
          sx={{ width: 244 }}
        >
          {t('toTop', 'TOPページへ')}
        </Button>
      </Stack>
    </BaseLayout>
  )
}
